import NetxQueryClient from '@netx/core-next/lib/queryClient';
import type {BatchJobId as UUID} from '@netx/core-app/models/batchJob';

/**
 * `getProgressReport` request params
 * (what is used to send to server)
 */
export interface GetProgressReportRequestOptions {
	uuid: UUID;
}

/**
 * `getProgressReport` request
 * (what gets sent to the server)
 */
export type GetProgressReportRequest = [
	GetProgressReportRequestOptions['uuid'],
];

/**
 * `getProgressReport` response
 * (what comes back from the server)
 */
export interface GetProgressReportResponse {
	result: GetProgressReportResult;
}

/**
 * `getProgressReport` result
 * (what is utilized from the server response)
 */
export type GetProgressReportResult = {
	percentComplete: number;
	jobTitle: string;
	secondsToReload: number;
	completeUrl: null | string;
	details: string;
	increment: number;
	startTime: number;
	runningTime: number;
	runningTimeLabel: null | string;
	estimatedTime: null | number;
	userId: number;
	notifyOnComplete: boolean;
	size: number;
	progressMessages: null | any; // TODO
	progressMessageCount: number;
	warningObject: null | any; // TODO generic
};

export const getProgressReportEndpoint = 'getProgressReport';

/**
 * Get progress report for uuid
 * @param fetchParams Fetch params
 */
export const getProgressReport = async (
	{uuid}: GetProgressReportRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetProgressReportRequest = [uuid];

	return client
		.post<GetProgressReportResponse>(getProgressReportEndpoint, requestParams, {
			signal,
		})
		.then((response) => response.data.result);
};

export default getProgressReport;
